import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconMinus = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconMinus.dimensions.width} ${IconMinus.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M20.341 0H.987a.986.986 0 100 1.974h19.354a.987.987 0 000-1.974z"
        fill={color || Color.premiumBlack}
        fillRule="nonzero"
      />
    </Svg>
  )
}

IconMinus.dimensions = {
  width: 21.327,
  height: 1.973,
}

export default IconMinus
